module.exports = __webpack_public_path__ + "img/hand.361d7c3b.jpg";